module.exports = __webpack_public_path__ + "img/back_m_active2.ca3685e0.png";